module.exports = __webpack_public_path__ + "img/LV2.7f51335b.png";